export default __webpack_public_path__ + "static/media/banner-home.5dc46661.jpg";